export const INFORMATION_ICON_TEST_ID =
	'issue.views.common.child-issues-panel.heading.title.information-panel';
export const INFORMATION_PANEL_TEST_ID = `${INFORMATION_ICON_TEST_ID}--inline-dialog`;
